<div class="main-container">
  <div class="left-container">
    <app-login-load></app-login-load>
  </div>
  <div class="right-container bg-white">

    <div class=" h-full px-3 flex flex-column justify-content-center px-7">

        <div class="flex align-items-center my-3">
          @if (_auth.appConfig() && _auth.appConfig().parentBrandLogoURL) {
            <div>
              <img [src]="_auth.appConfig().parentBrandLogoURL" alt="logo" class="logo" [style]="{ height:( _auth.appConfig().parentBrandLogoHeightLogin ? _auth.appConfig().parentBrandLogoHeightLogin + 'rem' : '4rem') }"/>
            </div>
            <div class="h-3rem bg-gray-300 mr-1" [style]="{width : '2px'}"></div>
          }
          @if (_auth.appConfig() && _auth.appConfig().brandLogoURL && _auth.appConfig().loginDefaultBrand === 'brandLogoURL') {
            <div>
              <img [src]="_auth.appConfig().brandLogoURL" alt="logo" class="logo" [style]="{ height:( _auth.appConfig().brandLogoHeightLogin ? _auth.appConfig().brandLogoHeightLogin + 'rem' : '4rem') }"/>
            </div>
          }@else if(_auth.appConfig() && _auth.appConfig().brandName && _auth.appConfig().loginDefaultBrand === 'brandName') {
            <div [style]="_auth.appConfig().brandNameStyle">
              {{_auth.appConfig().brandName}}
            </div>
          }@else if(_auth.appConfig() && _auth.appConfig().brandLogoURL && _auth.appConfig().brandName){
            <div>
              <img [src]="_auth.appConfig().brandLogoURL" alt="logo" class="logo" [style]="{ height:( _auth.appConfig().brandLogoHeightLogin ? _auth.appConfig().brandLogoHeightLogin + 'rem' : '4px') }"/>
            </div>
            <div [style]="_auth.appConfig().brandNameStyle">
              {{_auth.appConfig().brandName}}
            </div>
          }
        </div>

        @if(!isNewUser) {
          <app-change-password-form />
        } @else {

          <div class="p-3 flex flex-column justify-content-center align-items-center tfa_container">
            <p-stepper [activeStep]="activeStep" [linear]="true" orientation="vertical">
              <p-stepperPanel class="text-sm" header="Account setup">
                <ng-template pTemplate="content">
                  <div class="password_area">
                    <app-change-password-form
                      (closePasswordDialogEvent)="onPasswordSubmit()"
                    />
                  </div>
                </ng-template>
              </p-stepperPanel>
              <p-stepperPanel class="text-sm" header="Set up Two-Factor Authentication">
                <ng-template
                  pTemplate="content"
                  let-prevCallback="prevCallback"
                  let-nextCallback="nextCallback"
                  let-index="index"
                >
                  <app-tfa [tfaInputData]="tfaData" [isTfaConfigured]="_auth.userDetail().isTfaConfigured"/>
                </ng-template>
              </p-stepperPanel>
            </p-stepper>
          </div>
        }
    </div>

  </div>
</div>



